var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7156 4.75021C15.0837 5.09413 15.0961 5.66385 14.7434 6.02272L7.66645 13.2227C7.49471 13.3974 7.25802 13.4974 7.00982 13.4999C6.76161 13.5025 6.5228 13.4075 6.34729 13.2364L3.27036 10.2364C2.90988 9.88492 2.90988 9.31508 3.27036 8.9636C3.63085 8.61213 4.21531 8.61213 4.57579 8.9636L6.98596 11.3135L13.4105 4.77729C13.7632 4.41842 14.3475 4.4063 14.7156 4.75021Z",
    fill: "#386BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDone);
export default __webpack_public_path__ + "static/media/status-done.202f597ee69ffca90c53c6ffd0642a32.svg";
export { ForwardRef as ReactComponent };